import React from 'react';
import { Pagination } from '@components';
import { formatUseYn } from '@utils/formatUseYn';

const CodeDListSection = ({
    filterCodeDList,
    data,
    pageIndex,
    handlePageChange,
    handleCodeD,
    setDDetailItem,
    setDDetailOpen
}) => {
    return (
        <section className="wp75 flex flex-col">
            <div className="section-tit-wrap">
                <h3 className="border-left-primary !text-[19px] md:!text-[21px]">
                    &nbsp;공통코드(D) 조회
                    <span className="total-txt !text-[15px] md:!text-[16px]">
                        | 총 <span className='red'>{filterCodeDList.length || 0}</span> 건
                    </span>
                </h3>
            </div>

            {/* Mobile: 축약 테이블 + 상세(모달) */}
            <div className="md:hidden table-container overflow-x-auto table-list-wrapper [-webkit-overflow-scrolling:touch]">
                <table className="table-list min-w-max !text-[15px] md:!text-[16px] lg:!text-[17px]" style={{ width: "100%" }}>
                    <colgroup>
                        <col style={{ width: '30%' }} />
                        <col style={{ width: '50%' }} />
                        <col style={{ width: '10%' }} />
                        <col style={{ width: '10%' }} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>공통코드</th>
                            <th>공통코드명</th>
                            <th>사용</th>
                            <th>정렬</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filterCodeDList && filterCodeDList.length > 0 ? (
                            filterCodeDList.map((item) => (
                                <tr
                                    key={item.comdCode}
                                    onClick={() => {
                                        handleCodeD(item.comdCode);
                                        setDDetailItem(item);
                                        setDDetailOpen(true);
                                    }}
                                    style={{ cursor: "pointer" }}>
                                    <td className="font-mono">{item.comdCode}</td>
                                    <td>{item.comdName}</td>
                                    <td>{formatUseYn(item.duseYn)}</td>
                                    <td className="font-mono">{item.dsort}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={4} className="table-empty" style={{ textAlign: 'center' }}>
                                    조회 결과가 없습니다.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Desktop: 전체 테이블 */}
            <div className="hidden md:block table-container overflow-x-auto table-list-wrapper [-webkit-overflow-scrolling:touch]">
                <table className="table-list min-w-max !text-[15px] md:!text-[16px] lg:!text-[17px]" style={{ width: "100%" }}>
                    <colgroup>
                        <col style={{ width: '10%' }} />
                        <col style={{ width: '10%' }} />
                        <col style={{ width: '10%' }} />
                        <col style={{ width: '10%' }} />
                        <col style={{ width: '10%' }} />
                        <col style={{ width: '5%' }} />
                        <col style={{ width: '5%' }} />
                        <col style={{ width: '20%' }} />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>공통코드</th>
                            <th>공통코드명</th>
                            <th>사용자정의 1</th>
                            <th>사용자정의 2</th>
                            <th>사용자정의 3</th>
                            <th>정렬 순서</th>
                            <th>사용 여부</th>
                            <th>비고</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filterCodeDList && filterCodeDList.length > 0 ? (
                            filterCodeDList.map((item) => (
                                <tr
                                    key={item.comdCode}
                                    onClick={() => handleCodeD(item.comdCode)}
                                    style={{ cursor: "pointer" }}>
                                    <td>{item.comdCode}</td>
                                    <td>{item.comdName}</td>
                                    <td>{item.usrDfn1 || "-"}</td>
                                    <td>{item.usrDfn2 || "-"}</td>
                                    <td>{item.usrDfn3 || "-"}</td>
                                    <td>{item.dsort}</td>
                                    <td>{formatUseYn(item.duseYn)}</td>
                                    <td style={{ textAlign: "left" }}>{item.dnotice}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={8} className="table-empty" style={{ textAlign: 'center' }}>
                                    조회 결과가 없습니다.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
                <Pagination
                    totalPages={Math.ceil(
                        data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                    )}
                    currentPage={pageIndex}
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={10}
                />
            )}
        </section>
    );
};

export default CodeDListSection;
